module.exports = __webpack_public_path__ + "static/dev-4f43ba939bb554bd11384a0048ee5b4d.png";